/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbShowMoreTextContainer } from "abreact/layout/AbShowMoreTextContainer";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import * as React from "react";
/**
 * A React component that renders a piece of text content.
 */
export function AbTextContent(props) {
  const classes = [props.singleLine && "ab-single-line"];
  const content = /*#__PURE__*/React.createElement(AbWithTooltip, AbWithTooltip.makeClippedProps(props.tooltip, props.text), /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-text-content", props, classes), props.text));
  return props.truncateLongContent && !props.singleLine ? /*#__PURE__*/React.createElement(AbShowMoreTextContainer, null, content) : content;
}
//# sourceMappingURL=AbTextContent.js.map
